<script>
import catalog from '@/mixins/catalog';
export default {

  name: 'listing-card',
  //components: {"vue-slick-carousel": VueSlickCarousel},
  props: ['item'],  
  mixins: [catalog],
  //template: '#location',
  data: function(){

      return {
        offerActive:{},
        indexActive:0,
        settings:{slidesToShow:1,
                                                fade:true,
                                                arrows:false,
                                                lazyLoad: "ondemand",
                                                speed: 250
                                                //asNavFor: this.$refs.slickSmallGallery


                            }
      }
  },   
  created: function(){

    this.offerActive = this.item.CUSTOM_OFFERS[0];
    

  }, 
  methods: {

    setOffer()
    {
        this.item.ID = this.offerActive.ID;
        this.item.NAME = this.offerActive.NAME;
        this.item.FORMAT_PRICE = this.offerActive.FORMAT_PRICE;
        this.item.FORMAT_PRICE_OLD = this.offerActive.FORMAT_PRICE_OLD;
        this.item.PRICE_OLD = this.offerActive.PRICE_OLD;
        this.item.DISCOUNT_PR = this.offerActive.DISCOUNT_PR;
        this.item.DETAIL_PAGE_URL = this.offerActive.DETAIL_PAGE_URL;
        //console.log(this.offerActive);
    },

    onSlideChange(event)
    {
        
        this.indexActive = event.detail[0].realIndex;
        //console.log(this.indexActive);
                                
    },

    hoverControlImage: function(index, photo, item){

        item.GALLERY.forEach(element => {
            
            element.active = false;
        });
        //console.log("навели");
        // console.log(photo);
        this.$set(photo, 'active', true);

        //photo.active = true;
        //console.log(this.$refs);

        //swiper.slideTo(index, speed, runCallbacks);
        this.$refs['swiper_'+item.ID].swiper.slideTo(index);

    },



  }

}



</script>

<style>
    .gallery-control
    {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 7px;
    display: flex;
    justify-content: space-between;
    z-index: 88;
    }

    .shop-one-cont-h .select
    {
        width:100%;
        box-sizing: border-box;
    }
    
    .select::after {

        background: white;
        top: 2px !important;
        right: 2px !important;
        box-sizing: content-box !important;
        height: 30px !important;
        width: 5% !important;
        display: flex;
        align-items: center;
    }

    .label-select
    {
        margin-bottom:5px;
        display:block
    }

    .block-select
    {
        height:60px
    }
</style>

<template>
    <div class="shop-one-cont-h">
                
                <div class="actions" v-if="item.ACTIONS" v-for="ACTION in item.ACTIONS">
                    <div class="item-promo-popular-peop" v-if="ACTION.VALUE=='3547'"></div> 
                    <div class="item-promo-akcii"  v-if="ACTION.VALUE=='3546'"></div> 
                    <div class="item-promo-new"  v-if="ACTION.VALUE=='3545'"></div>
                    <div class="item-promo-xit"  v-if="ACTION.VALUE=='3548'"></div>
                    <div class="item-promo-rent-i"  v-if="ACTION.VALUE=='3549'"></div>
                    <div class="item-promo-del-i"  v-if="ACTION.VALUE=='6070'"></div>
                </div>
            

                <div class="shop-one" >
                        <div class="flex-cont">
                            <a :href="item.DETAIL_PAGE_URL">
                                <div class="shop-img">
                                    
                                       
                                        <swiper-container
                                                :slides-per-view="1"
                                                :loop="true"
                                                :ref="'swiper_'+item.ID"
                                                effect="fade"
                                                @slidechange="onSlideChange"
                                            >
                                            <swiper-slide v-for="(photo, index) in item.GALLERY" :key="index" lazy="true">
                                                <div class="gallery-one" >
                                                    <img v-if="index == 0" :src="photo.src" :alt="item.NAME" :width="photo.width" :height="photo.height" loading="lazy">
                                                    <img v-if="index > 0 && indexActive == index" :src="photo.src" :alt="item.NAME" :width="photo.width" :height="photo.height" loading="lazy"  class="swiper-lazy">
                                     
                                                    <!-- <div class="swiper-lazy-preloader"></div> -->
                                                </div>
                                            </swiper-slide>
                        
                                        </swiper-container>  
                                        
                                        
                                        <div class="old-price-block-img old-price-block" v-if="item.PRICE_OLD > 0">
                                            <del class="hide dis-pr-f" v-html="item.FORMAT_PRICE_OLD"></del>  
                                            <div class="dis-pr">-{{item.DISCOUNT_PR}}%</div>
                                        </div> 
                                </div>
                                <div class="gallery-control">
                                    <div class="part-control" 
                                        v-for="(photo, index) in item.GALLERY" 
                                        :style="'width:'+photo.width_control+'%'"
                                        @mouseenter="hoverControlImage(index, photo, item)"
                                        :class="{active:photo.active}"
                                        :key="index"
                                        >
                                    
                                    </div>
                                </div>
                            </a>
                        </div>
                            <!-- <div class="list-mar-quick">
                                <a class="quick-look-button" href="">
                                    Быстрый просмотр
                                </a>
                            </div> -->
                            <div class="shop-name-container">
                                <a :href="item.DETAIL_PAGE_URL" class="shop-name">
                                    {{item.NAME}}
                                </a>
                            
                            </div> 
                        
                            <div class="pos-pr-rel">
                                <div class="price-list" v-html="item.FORMAT_PRICE">
                                
                                </div> 
                                <div class="old-price-block" v-if="item.PRICE_OLD > 0">
                                    <del class="dis-pr-f" v-html="item.FORMAT_PRICE_OLD"></del>  
                                    <div class="dis-pr hide">-{{item.DISCOUNT_PR}}%</div>
                                </div> 
                            </div>

                            <!-- <div class="block-select">
                                <label class='label-select' v-if="item.CUSTOM_OFFERS">Размеры ({{item.CUSTOM_OFFERS.length}}):</label>
                                <div class="select" v-if="item.CUSTOM_OFFERS">
                                    <select name="" id="" v-model="offerActive" @change="setOffer">
                                        <option :value="offer" v-for="offer in item.CUSTOM_OFFERS">
                                            {{offer.PROPS.OFFER_NAME?offer.PROPS.OFFER_NAME[0].VALUE:offer.NAME}}
                                        </option>
                                    </select>
                                </div>
                            </div> -->

                      
                            
                            <!-- <button @click="addToBasket(item.ID)">В корзину</button> -->

                                <div class="stars" >
                                    <div class="star" v-for="star in 5" :class="{active: getRating(star, item)}"></div>
                                    <div class="count-feed">({{getCountFeed(item)}})</div>
                                </div>


                            <div class="eh-fast-order">
                                <!-- <a class="de-last-incart" href="">

                                </a> -->
                                <div class="delivery-list">
                                    Доставка: 
                                    <b v-if="item.PROPS.DELIVERY">{{item.PROPS.DELIVERY[0].VALUE_TEXT}}</b>
                                </div>
                                <a class="one-click-order feed-back-call-b" v-if="!item.BASKET" @click.stop.prevent="addToBasket(item)">
                                    Купить
                                </a>
                                <a class="one-click-order feed-back-call-b" href="/personal/cart/" v-if="item.BASKET" :class="{active: item.BASKET}" > 
                                    В корзину
                                </a>
                                
                          </div>
                          <div class="block-variants" v-if="item.CUSTOM_OFFERS.length > 1">
                                    <label class='label-variants'>Варианты исполнения ({{item.CUSTOM_OFFERS.length}}):</label>
                                    <div class="link-variant" v-if="item.CUSTOM_OFFERS">
                                        <a :href="offer.DETAIL_PAGE_URL" v-for="(offer, index) in item.CUSTOM_OFFERS" :class="{active:index==0}">
                                            {{offer.PROPS.OFFER_NAME?offer.PROPS.OFFER_NAME[0].VALUE:offer.NAME}}
                                        </a>

                                    </div>
                                </div>

                          <div class="compare-like-cont">
                                <!-- <div class="eh-compare">
                                    <a v-if="!item.COMPARE" href="/" @click.stop.prevent="addProductCompare(item)">
                                        <span >
                                            К сравнению
                                        </span> 
                                    </a>

                                    <a v-if="item.COMPARE" href="/compare" :class="{active: item.COMPARE}">
                                           В сравнение
                                    </a>
                                </div> -->

                                <div class="eh-like-t">
                                        <a class="eh-like-e" v-if="!item.FAVORITE" href="" @click.stop.prevent="addToFavorite(item)"> 
                                            <span>В избранное</span> 
                                        </a>
                                        <a class="eh-like-f" v-if="item.FAVORITE" href="/favorite/" :class="{active: item.FAVORITE}"> 
                                            <span>Перейти в избранное</span> 
                                        </a>
                                </div> 
                          </div>
                          

                </div>
            </div> 
</template>


<style scoped>

.shops-bor-cart {
    position: relative;
    width: auto;
    height: 400px;
}


.shop-one-cont-h {
    background: white;
    height: 400px;
    padding: 15px;
    border: 1px #EBEBEB solid;
    margin-top: -1px;
    padding-top: 5px;
    transition: .7s;
    overflow: hidden;
}

.shop-img {
    text-align: center;
    margin-top: 7px;
    display: block;
}

.gallery-control {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 7px;
    display: flex;
    justify-content: space-between;
    z-index: 88;
}

.part-control {
    height: 100%;
    border-bottom: 1px solid #bebebe;
}


.part-control.active
{
  border-bottom:2px solid #ff9601;
  
}

.gallery-one {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
    position: relative;
    z-index: 11;
}

.shop-name-container {
    height: 59px;
    overflow: hidden;
    margin-top: 10px;
}


.shop-name {
    font-size: 16px;
    color: #3979c1;
    text-decoration: underline;
}

.pos-pr-rel {
    display: flex;
    margin-bottom: 10px;
}

.price-list {
    font-family: sans-serif;
    color: black;
    font-size: 18px;
    font-weight: 700;
    margin-top: 5px;
}

.stars {
    margin-top: 15px;
    margin-bottom: 15px;
    display: flex;
}

.star.active {
    background: linear-gradient(to bottom, rgba(224, 194, 75, 1) 0%, rgba(207, 125, 0, 1) 100%);
}

.star.active:before {
    background: linear-gradient(to bottom, rgba(243, 212, 85, 1) 0%, rgba(238, 164, 0, 1) 100%);
}


.shop-one .eh-fast-order {
    margin-top: 5px;
}

.delivery-list {
    font-size: 12px;
    line-height: 20px;
    margin: 6px 0 0;
    color: #999;
}

.delivery-list b {
    color: #000;
}

.feed-back-call-b {
    background-color: #f1832a;
    text-decoration: none;
    color: #fff;
    border-radius: 2px;
    padding: 7px 11px 7px;
    text-transform: uppercase;
    font-size: 12px;
    cursor: pointer;
    display: inline-block;
}

.compare-like-cont {
    display: flex;
    justify-content: space-between;
    margin-top: 3px;
}

.eh-like-t {
    font-family: 'PT_Sans';
    height: 20px;
    font-size: 14px;
    color: #FF9601;
    text-decoration: none;
    margin-left: 1px;
    margin-top: 14px;
}

.eh-like-e {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0LjY2NjYgOS41MDgzNEMyNC42NjY2IDEwLjI4ODEgMjQuNTM1OSAxMS4wNTA5IDI0LjI3MTkgMTEuODAxMkwyNC4yNzE4IDExLjgwMTVDMjQuMDEzNyAxMi41MzI5IDIzLjU0MjcgMTMuMzgxNiAyMi44MjIzIDE0LjM1MDlMMjIuODIyMSAxNC4zNTEyQzIyLjEwMjMgMTUuMzIwNSAyMS4xMTc0IDE2LjQzNSAxOS44NTU0IDE3LjY5NzFDMTguNTg4NiAxOC45NjM5IDE2Ljk3ODkgMjAuNDc3NSAxNS4wMjI5IDIyLjIzOThDMTUuMDIyNyAyMi4yNCAxNS4wMjI1IDIyLjI0MDIgMTUuMDIyMyAyMi4yNDA0TDE0IDIzLjE1NjlMMTIuOTc3NyAyMi4yNDA0QzEyLjk3NzUgMjIuMjQwMiAxMi45NzcyIDIyLjI0IDEyLjk3NyAyMi4yMzk4QzExLjAyMTEgMjAuNDc3NSA5LjQxMTM3IDE4Ljk2MzkgOC4xNDQ1OSAxNy42OTcxQzYuODgyNTUgMTYuNDM1IDUuODk3NjEgMTUuMzIwNSA1LjE3NzgzIDE0LjM1MTJMNS4xNzc2MSAxNC4zNTA5QzQuNDU3MTEgMTMuMzgxMyAzLjk4NjU3IDEyLjUzMjcgMy43MjkzIDExLjgwMTVMMy43MjkwMyAxMS44MDA3QzMuNDY0NCAxMS4wNTA0IDMuMzMzMzEgMTAuMjg3OCAzLjMzMzMxIDkuNTA4MzRDMy4zMzMzMSA3LjkyOTU1IDMuODUxNjMgNi42NjI1NyA0Ljg3NzkyIDUuNjM2MjhDNS45MDQyMSA0LjYwOTk5IDcuMTcxMTkgNC4wOTE2NyA4Ljc0OTk4IDQuMDkxNjdDOS42MTQ4OCA0LjA5MTY3IDEwLjQzMjYgNC4yNzM1IDExLjIxMzUgNC42MzkwM0MxMS45OTYgNS4wMDUzIDEyLjY2ODcgNS41MTk0OCAxMy4yMzggNi4xODkzMkwxNCA3LjA4NTcyTDE0Ljc2MTkgNi4xODkzMkMxNS4zMzEzIDUuNTE5NDggMTYuMDAzOSA1LjAwNTMgMTYuNzg2NCA0LjYzOTAzQzE3LjU2NzMgNC4yNzM1IDE4LjM4NTEgNC4wOTE2NyAxOS4yNSA0LjA5MTY3QzIwLjgyODggNC4wOTE2NyAyMi4wOTU3IDQuNjA5OTkgMjMuMTIyIDUuNjM2MjhDMjQuMTQ4MyA2LjY2MjU3IDI0LjY2NjYgNy45Mjk1NSAyNC42NjY2IDkuNTA4MzRaIiBzdHJva2U9IiNGRjk2MDEiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K);
    background-repeat: no-repeat;
    height: 20px;
    background-position: -1px -1px;
    background-size: 25px;
    padding-left: 27px;
    padding-bottom: 5px;
}

.eh-like-t span {
    border-bottom: 1px dashed #FF9601;
    height: 20px;
    font-size: 13px;
    color: #FF9601;
}

</style>